(function () {
  function init() {
    var MOBILE_BP = 480;

    function isMobile() {
      return window.innerWidth <= MOBILE_BP;
    }

    function applyBottomBarStyles(host) {
      var shadow = host.shadowRoot;
      var mobile = isMobile();

      if (mobile) {
        // dg-bottom, not dg-modal: dg-modal is DataGrail's own centered/
        // floating card positioning, which is why this was rendering high up
        // near the header instead of pinned to the bottom like the Figma
        // reference. dg-bottom is the same anchor-to-viewport-bottom
        // positioning already used (and confirmed working) on desktop below —
        // only the internal layout (stacked vs. row) differs by breakpoint.
        host.classList.remove('dg-left', 'dg-right', 'dg-modal');
        host.classList.add('dg-bottom');

        var app = shadow.querySelector('.dg-app');
        if (app) app.style.cssText = 'display:flex;flex-direction:column;width:100%;max-height:90vh;overflow-y:auto;padding:24px;background:#1a1a1a;box-sizing:border-box;';

        var header = shadow.querySelector('.dg-header');
        if (header) header.style.cssText = 'display:flex;justify-content:flex-end;margin-bottom:16px;';

        var title = shadow.querySelector('.dg-text-title');
        if (title) title.style.display = 'none';

        var headerClose = shadow.querySelector('.dg-header-close');
        if (headerClose) headerClose.style.cssText = 'color:#ffffff;background:transparent;border:none;cursor:pointer;padding:0;';

        var lang = shadow.querySelector('.dg-main-language-dropdown');
        if (lang) lang.style.display = 'none';

        var links = shadow.querySelector('.dg-links');
        if (links) links.style.display = 'none';

        // DataGrail's own explanation element isn't always present under
        // this class combo (their default collapsed mobile view can omit it
        // entirely) — and we fully overwrite its copy with our own
        // legally-approved text regardless, so there's nothing to lose by
        // creating it ourselves when DataGrail doesn't provide one.
        var text = shadow.querySelector('.dg-main-content-explanation.dg-text-body')
          || shadow.querySelector('#dg-custom-legal-text');
        if (!text && app) {
          text = document.createElement('p');
          text.id = 'dg-custom-legal-text';
          app.insertBefore(text, header ? header.nextSibling : app.firstChild);
        }
        if (text) {
          text.style.cssText = 'color:#ffffff;font-size:14px;line-height:1.6;margin:0 0 32px;display:block;';
          text.textContent = '';
          text.innerHTML = 'This website uses cookies and tracking technologies for navigation, analysis, and personalized ads, as detailed in our <a href="https://www.luluandgeorgia.com/pages/privacy-policy" style="color:inherit;text-decoration:underline;">Privacy Policy</a>. Preferences can be managed below. Use of this website confirms your acceptance of our <a href="https://www.luluandgeorgia.com/pages/terms-and-conditions" style="color:inherit;text-decoration:underline;">Terms of Use</a>.';
        }

        var rejectBtn = shadow.querySelector('.dg-button.reject_all');
        if (rejectBtn) rejectBtn.style.display = 'none';

        var saveBtn = shadow.querySelector('.dg-button.custom');
        if (saveBtn) saveBtn.style.display = 'none';

        var acceptBtn = shadow.querySelector('.dg-button.accept_all');
        if (acceptBtn) {
          acceptBtn.style.cssText = 'display:block;width:100%;box-sizing:border-box;background:#ffffff;color:#1a1a1a;border:none;padding:16px;font-size:13px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;border-radius:0;margin:0 0 16px;cursor:pointer;text-align:center;';
          acceptBtn.textContent = 'Accept';
        }

        var customizeBtn = shadow.querySelector('.dg-button.open_layer');
        if (customizeBtn) {
          customizeBtn.style.cssText = 'display:block;width:100%;box-sizing:border-box;background:transparent;color:#ffffff;border:none;padding:12px;font-size:13px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;margin:0;cursor:pointer;text-align:center;';
          customizeBtn.textContent = 'Cookie Settings';
        }
      } else {
        host.classList.remove('dg-left', 'dg-right', 'dg-modal');
        host.classList.add('dg-bottom');

        var app = shadow.querySelector('.dg-app');
        if (app) app.style.cssText = 'display:flex;flex-direction:row;align-items:center;flex-wrap:nowrap;justify-content:space-between;width:100%;box-sizing:border-box;padding:16px 24px;gap:16px;background:#1a1a1a;max-height:none;';

        var lang = shadow.querySelector('.dg-main-language-dropdown');
        if (lang) lang.style.display = 'none';

        var links = shadow.querySelector('.dg-links');
        if (links) links.style.display = 'none';

        var header = shadow.querySelector('.dg-header');
        if (header) header.style.display = 'none';

        // Same fallback as the mobile branch above — DataGrail doesn't
        // reliably provide this element, and we overwrite its copy entirely
        // anyway.
        var text = shadow.querySelector('.dg-main-content-explanation.dg-text-body')
          || shadow.querySelector('#dg-custom-legal-text');
        if (!text && app) {
          text = document.createElement('p');
          text.id = 'dg-custom-legal-text';
          app.insertBefore(text, app.firstChild);
        }
        if (text) {
          text.style.cssText = 'flex:1;min-width:0;max-width:800px;font-size:13px;line-height:1.5;margin:0;color:#ffffff;overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;';
          text.textContent = '';
          text.innerHTML = 'This website uses cookies and tracking technologies for navigation, analysis, and personalized ads, as detailed in our <a href="https://www.luluandgeorgia.com/pages/privacy-policy" style="color:inherit;text-decoration:underline;">Privacy Policy</a>. Preferences can be managed on the right. Use of this website confirms your acceptance of our <a href="https://www.luluandgeorgia.com/pages/terms-and-conditions" style="color:inherit;text-decoration:underline;">Terms of Use</a>.';
        }

        var rejectBtn = shadow.querySelector('.dg-button.reject_all');
        if (rejectBtn) rejectBtn.style.display = 'none';

        var saveBtn = shadow.querySelector('.dg-button.custom');
        if (saveBtn) saveBtn.style.display = 'none';

        var customizeBtn = shadow.querySelector('.dg-button.open_layer');
        if (customizeBtn) {
          customizeBtn.style.cssText = 'display:inline-block;width:auto;white-space:nowrap;background:transparent;color:#ffffff;border:none;padding:10px 0;font-size:13px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;margin:0;cursor:pointer;flex-shrink:0;';
          customizeBtn.textContent = 'Cookie Settings';
        }

        var acceptBtn = shadow.querySelector('.dg-button.accept_all');
        if (acceptBtn) {
          acceptBtn.style.cssText = 'display:inline-block;width:auto;white-space:nowrap;background:#ffffff;color:#1a1a1a;border:none;padding:10px 28px;font-size:13px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;border-radius:0;margin:0;cursor:pointer;flex-shrink:0;';
          acceptBtn.textContent = 'Accept';
        }

        var group = shadow.querySelector('#dg-button-group');
        if (group) group.style.display = 'flex';

        if (!shadow.querySelector('#dg-custom-close') && app) {
          var closeBtn = document.createElement('button');
          closeBtn.id = 'dg-custom-close';
          closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="#ffffff"/></svg>';
          closeBtn.style.cssText = 'background:transparent;border:none;cursor:pointer;padding:4px;flex-shrink:0;display:flex;align-items:center;';
          closeBtn.addEventListener('click', function () {
            var original = shadow.querySelector('.dg-header-close');
            if (original) original.click();
            else host.style.display = 'none';
          });
          app.appendChild(closeBtn);
        }

        if (!shadow.querySelector('#dg-button-group') && app) {
          var btnGroup = document.createElement('div');
          btnGroup.id = 'dg-button-group';
          btnGroup.style.cssText = 'display:flex;flex-direction:row;align-items:center;gap:24px;flex-shrink:0;margin-left:auto;';
          var cBtn = shadow.querySelector('.dg-button.open_layer');
          var aBtn = shadow.querySelector('.dg-button.accept_all');
          var xBtn = shadow.querySelector('#dg-custom-close');
          if (cBtn) btnGroup.appendChild(cBtn);
          if (aBtn) btnGroup.appendChild(aBtn);
          if (xBtn) btnGroup.appendChild(xBtn);
          app.appendChild(btnGroup);
        }
      }
    }

    function applyModalStyles(host) {
      var shadow = host.shadowRoot;
      var mobile = isMobile();

      var app = shadow.querySelector('.dg-app');
      if (app) app.style.cssText = 'display:flex;flex-direction:column;width:' + (mobile ? 'calc(100% - 32px)' : '600px') + ';max-height:80vh;overflow-y:auto;padding:32px' + (mobile ? ' 24px' : '') + ';background:#1a1a1a;box-sizing:border-box;';

      var header = shadow.querySelector('.dg-header');
      if (header) header.style.cssText = 'display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;';

      var title = shadow.querySelector('.dg-text-title');
      if (title) title.style.cssText = 'color:#ffffff;font-size:18px;font-weight:600;margin:0;';

      var headerClose = shadow.querySelector('.dg-header-close');
      if (headerClose) headerClose.style.cssText = 'color:#ffffff;background:transparent;border:none;cursor:pointer;padding:0;';

      var lang = shadow.querySelector('.dg-main-language-dropdown');
      if (lang) lang.style.display = 'none';

      var text = shadow.querySelector('.dg-main-content-explanation.dg-text-body');
      if (text) text.style.cssText = 'color:#ffffff;font-size:13px;line-height:1.6;margin:0 0 16px;max-width:none;display:block;';

      var links = shadow.querySelector('.dg-links');
      if (links) links.style.cssText = 'display:block;margin-bottom:24px;';

      shadow.querySelectorAll('.dg-main-content-policy-option').forEach(function (opt) {
        opt.style.cssText = 'background:transparent;border-top:1px solid rgba(255,255,255,0.15);padding:20px 0;';
      });
      shadow.querySelectorAll('.dg-main-content-policy-option-heading').forEach(function (h) {
        h.style.color = '#ffffff';
      });
      shadow.querySelectorAll('.dg-main-content-policy-option strong').forEach(function (s) {
        s.style.color = '#ffffff';
      });

      var btnPadding = mobile ? '16px' : '10px 28px';
      var btnMarginTop = mobile ? '12px' : '16px';

      var saveBtn = shadow.querySelector('.dg-button.custom');
      if (saveBtn) saveBtn.style.cssText = 'display:' + (mobile ? 'block;width:100%;box-sizing:border-box;text-align:center;' : 'inline-block;width:auto;') + 'background:#ffffff;color:#1a1a1a;border:none;padding:' + btnPadding + ';font-size:13px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;border-radius:0;margin:16px ' + (mobile ? '0' : '8px') + ' 0 0;cursor:pointer;';

      var acceptBtn = shadow.querySelector('.dg-button.accept_all');
      if (acceptBtn) acceptBtn.style.cssText = 'display:' + (mobile ? 'block;width:100%;box-sizing:border-box;text-align:center;' : 'inline-block;width:auto;') + 'background:transparent;color:#ffffff;border:1px solid rgba(255,255,255,0.4);padding:' + btnPadding + ';font-size:13px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;border-radius:0;margin:' + btnMarginTop + ' ' + (mobile ? '0' : '8px') + ' 0 0;cursor:pointer;';

      var rejectBtn = shadow.querySelector('.dg-button.reject_all');
      if (rejectBtn) rejectBtn.style.cssText = 'display:' + (mobile ? 'block;width:100%;box-sizing:border-box;text-align:center;' : 'inline-block;width:auto;') + 'background:transparent;color:#ffffff;border:1px solid rgba(255,255,255,0.4);padding:' + btnPadding + ';font-size:13px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;border-radius:0;margin:' + btnMarginTop + ' 0 0;cursor:pointer;';

      var group = shadow.querySelector('#dg-button-group');
      if (group) group.style.display = 'none';
    }

    function applyStyles(host) {
      host.style.setProperty('--dg-consent-background-color', '#1a1a1a');
      host.style.setProperty('--dg-consent-background-border', 'none');
      host.style.setProperty('--dg-body-font-color', '#ffffff');
      host.style.setProperty('--dg-button-color', '#ffffff');
      host.style.setProperty('--dg-button-background', 'transparent');
      host.style.setProperty('--dg-button-border', 'none');
      host.style.setProperty('--consent-border-radius', '0');
      host.style.setProperty('--dg-button-radius', '0');
      host.style.setProperty('--dg-policy-option-description-font-color', '#ffffff');
      host.style.setProperty('--dg-policy-option-heading-color', '#ffffff');
      host.style.setProperty('--dg-category-text', '#ffffff');
      host.style.setProperty('--dg-option-background', 'transparent');
      host.style.setProperty('--palette-text-primary', '#ffffff');

      var isPreferenceCenter = !!host.shadowRoot.querySelector('.dg-main-content-policy-option');
      if (host.classList.contains('dg-modal') && isPreferenceCenter) {
        applyModalStyles(host);
      } else {
        applyBottomBarStyles(host);
      }

      // Reveals the banner once it's actually styled — see the CSS file for
      // the opacity:0 default this class lifts. DataGrail's raw markup stays
      // invisible (but still laid out, so it can be measured/positioned)
      // until we've finished, instead of flashing unstyled before this runs.
      host.classList.add('dg-ready');
    }

    // Deliberately not a MutationObserver on the host: DataGrail manages this
    // element's classes internally (view transitions, its own responsive
    // logic), and observing it means our re-apply and DataGrail's own updates
    // can retrigger each other indefinitely — a livelock with no thrown
    // error, which is what the previous observer-based version produced.
    // Polling instead means we only ever assert our own desired state and
    // never react to a change we didn't cause, so there's nothing to
    // feed back into. Fast while waiting for DataGrail to inject the banner
    // (keeps the unstyled flash imperceptible), then a cheaper cadence once
    // it's there — applyStyles() is a no-op write when already correct, so
    // continuing to poll indefinitely (to catch DataGrail switching views)
    // stays cheap.
    function tick() {
      var host = document.querySelector('aside[class*="dg-consent"]');
      if (host && host.shadowRoot) {
        applyStyles(host);
        setTimeout(tick, 300);
      } else {
        setTimeout(tick, 50);
      }
    }

    // Fast path for the initial appearance: a one-shot, narrowly-scoped
    // observer (childList only, no subtree) catches DataGrail inserting the
    // banner the instant it happens, instead of waiting for the next poll
    // tick. It disconnects itself the moment it fires, so unlike the earlier
    // host-attribute observer it never lingers to fight with DataGrail's own
    // class management. Only helps if DataGrail appends the banner directly
    // to <body> — tick() below is the fallback either way.
    var insertionObserver = new MutationObserver(function () {
      var host = document.querySelector('aside[class*="dg-consent"]');
      if (host && host.shadowRoot) {
        insertionObserver.disconnect();
        applyStyles(host);
      }
    });
    insertionObserver.observe(document.body, { childList: true });

    tick();
  }

  // Loaded from <head> per DataGrail's placement guidance, so defer this
  // DOM-querying logic until the body has actually been parsed.
  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
